<div class="w-full bg-fdfdf1 rounded-lg p-2">
  <!-- title and total amount -->
  <div (click)="toggleAccordion('udhaar')"
    class="cursor-pointer pb-2 border-b border-c19725 flex items-center justify-between gap-2">
    <div class="flex items-center justify-start gap-4">
      <p class="text-sm sm:text-base xl:text-lg font-semibold text-c19725">{{ udhaarSummary.title }}</p>
      <p class="w-5 h-5 bg-white rounded-full flex items-center justify-center">
        <svg [class.rotate-180]="accordionState.udhaar" class="transition-transform duration-300" viewBox="0 0 20 20"
          fill="none" xmlns="http://www.w3.org/2000/svg"
          class="fill-8a8a8a group-hover:fill-0d5bab size-5 transition-transform duration-300">
          <path d="M5.83398 8.3335L10.0007 12.5002L14.1673 8.3335H5.83398Z"></path>
        </svg>
      </p>
    </div>
    <p class="text-sm sm:text-base lg:text-lg font-semibold text-c19725">₹ {{ udhaarSummary.total | number:'1.2-2'
      }}
    </p>
  </div>
  <!-- scrollable area -->
  <div class="max-h-[300px] overflow-y-auto">
    <div *ngFor="let trans of transactions"
      class="overflow-x-auto w-full text-sm lg:text-base flex items-center gap-3 mt-2 border-b border-c19725/5 pb-2 last:border-0">
      <div *ngFor="let chip of getChips(trans)"
        class="bg-white px-2 py-1.5 rounded-md w-max shadow-sm border border-gray-50">
        <p class="flex items-center gap-2 w-max text-777 font-medium"><span class="text-686868">{{ chip.label
            }}</span>|<span class="text-1c1c1c">{{ chip.value }}</span></p>
      </div>
    </div>
    <div *ngIf="transactions.length === 0 && !isLoading" class="text-center py-8 text-gray-400 italic text-sm">
      No Udhaar entries found for this period.
    </div>
    <div *ngIf="isLoading" class="text-center py-8 text-c19725 animate-pulse text-sm">
      Loading Udhaar entries...
    </div>
  </div>

  <!-- Amount Table -->
  <div class="transition-all duration-300 ease-in-out overflow-hidden" [class.max-h-0]="!accordionState.udhaar"
    [class.max-h-[2000px]]="accordionState.udhaar">
    <div class="mt-2 overflow-x-auto w-full">
      <table class="daybook-table w-full overflow-hidden">
        <thead class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <th [attr.colspan]="!!isGst ? 6 : 3"></th>
            <th class="text-bb0000 whitespace-nowrap">AMOUNT CR</th>
            <th class="text-018f37 whitespace-nowrap">AMOUNT DR</th>
          </tr>
          <tr class="bg-edffb1">
            <th>TYPE</th>
            <th>CASH</th>
            <th *ngIf="!!isGst">BANK</th>
            <th *ngIf="!!isGst">CARD</th>
            <th *ngIf="!!isGst">ONLINE</th>
            <th>DISC</th>
            <th class="whitespace-nowrap">EXTRA AMT.</th>
            <th>TOTAL</th>
          </tr>
        </thead>
        <tbody class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-medium">
          <tr>
            <td class="text-018f37 whitespace-nowrap">AMOUNT IN :</td>
            <td class="text-018f37">{{ summary.amount_in.cash | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.bank | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.card | number:'1.2-2' }}</td>
            <td class="text-018f37" *ngIf="!!isGst">{{ summary.amount_in.online | number:'1.2-2' }}</td>
            <td class="text-018f37">{{ summary.amount_in.disc | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-018f37">{{ summary.amount_in.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap">AMOUNT OUT :</td>
            <td class="text-bb0000">{{ summary.amount_out.cash | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.bank | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.card | number:'1.2-2' }}</td>
            <td class="text-bb0000" *ngIf="!!isGst">{{ summary.amount_out.online | number:'1.2-2' }}</td>
            <td class="text-bb0000">{{ summary.amount_out.disc | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td class="text-bb0000">{{ summary.amount_out.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap">TODAY TOTAL :</td>
            <td [class.text-018f37]="summary.amount_in.cash - summary.amount_out.cash >= 0"
              [class.text-bb0000]="summary.amount_in.cash - summary.amount_out.cash < 0">{{ summary.amount_in.cash -
              summary.amount_out.cash | number:'1.2-2' }}</td>
            <td *ngIf="!!isGst" [class.text-018f37]="summary.amount_in.bank - summary.amount_out.bank >= 0"
              [class.text-bb0000]="summary.amount_in.bank - summary.amount_out.bank < 0">{{ summary.amount_in.bank -
              summary.amount_out.bank | number:'1.2-2' }}</td>
            <td *ngIf="!!isGst" [class.text-018f37]="summary.amount_in.card - summary.amount_out.card >= 0"
              [class.text-bb0000]="summary.amount_in.card - summary.amount_out.card < 0">{{ summary.amount_in.card -
              summary.amount_out.card | number:'1.2-2' }}</td>
            <td *ngIf="!!isGst" [class.text-018f37]="summary.amount_in.online - summary.amount_out.online >= 0"
              [class.text-bb0000]="summary.amount_in.online - summary.amount_out.online < 0">{{ summary.amount_in.online
              - summary.amount_out.online | number:'1.2-2' }}</td>
            <td [class.text-018f37]="summary.amount_in.disc - summary.amount_out.disc >= 0"
              [class.text-bb0000]="summary.amount_in.disc - summary.amount_out.disc < 0">{{ summary.amount_in.disc -
              summary.amount_out.disc | number:'1.2-2' }}</td>
            <td class="text-bb0000">0.00</td>
            <td [class.text-018f37]="summary.amount_in.total - summary.amount_out.total >= 0"
              [class.text-bb0000]="summary.amount_in.total - summary.amount_out.total < 0">{{ summary.amount_in.total -
              summary.amount_out.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-554646 whitespace-nowrap">OPENING BALANCE :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-554646">{{ openingBalance | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-bb0000 whitespace-nowrap">Today Total :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td [class.text-018f37]="summary.amount_in.total - summary.amount_out.total >= 0"
              [class.text-bb0000]="summary.amount_in.total - summary.amount_out.total < 0">{{ summary.amount_in.total -
              summary.amount_out.total | number:'1.2-2' }}</td>
          </tr>
          <tr>
            <td class="text-554646 whitespace-nowrap">CLOSING AMOUNT :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-554646">{{ openingBalance + summary.amount_in.total - summary.amount_out.total |
              number:'1.2-2' }}</td>
          </tr>
        </tbody>
        <tfoot class="text-right text-[13px] sm:text-sm lg:text-[15px] uppercase font-semibold">
          <tr class="bg-d9d9d9">
            <td class="text-black whitespace-nowrap">FINAL TOTAL :</td>
            <td [attr.colspan]="!!isGst ? 6 : 3"></td>
            <td class="text-black">₹ {{ openingBalance + summary.amount_in.total - summary.amount_out.total |
              number:'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>